"use client";

import { Atom, Beaker, Box, Cpu, Droplet, Flame, Layers, Shield } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PurposeAndFuture() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const materials = [{
    name: "AI Tools for Managers",
    description: "Mastering Artificial Intelligence tools to drive business productivity and automated decision-making.",
    tensile: "High Impact",
    temp: "MODERN & DIGITAL",
    Icon: Cpu
  }, {
    name: "Strategic Communication",
    description: "Advanced frameworks for leadership communication and organizational narrative management.",
    tensile: "Leadership",
    temp: "Global",
    Icon: Shield
  }, {
    name: "Digital Marketing",
    description: "Transformative digital strategies designed for sustainable growth in the African market.",
    tensile: "Growth",
    temp: "Dynamic",
    Icon: Layers
  }, {
    name: "PROFESSIONAL PUBLIC SPEAKING",
    description: "Tailored training programs built to empower teams with engineering-grade professional skills.",
    tensile: "Scalable",
    temp: "Robust",
    Icon: Box
  }];
  return <section data-section-id="2254" id="purpose-and-future" className="bg-background text-foreground py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-16 md:mb-20 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-6">
            <p className="font-mono text-xs md:text-sm tracking-[0.2em] uppercase mb-6" style={{
            color: "var(--chart-1)"
          }}>
              Our Offerings
            </p>
            <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] tracking-tight text-foreground">
              Empowering the next generation of leaders.
            </h2>
          </div>
          <div className="md:col-span-6 md:pt-4">
            <p className="text-base md:text-lg leading-relaxed text-muted-foreground max-w-xl font-default">
              From AI productivity to strategic leadership, our curated training programs
              give professionals and entrepreneurs the precise skills, tools, and 
              transformative knowledge their organizations demand.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {materials.map((material, i) => {
          const Icon = material.Icon;
          return <div data-index={i} key={material.name} className="group relative rounded-md border border-border bg-card p-7 md:p-8 transition-all duration-300 ease-out hover:-translate-y-1 shadow-md hover:shadow-xl border-l-4" style={{
            backgroundColor: "var(--card)",
            borderLeftColor: "var(--primary)"
          }}>
                {}
                <div className="mb-7 inline-flex h-[60px] w-[60px] items-center justify-center rounded-md transition-colors duration-300" style={{
              backgroundColor: "var(--muted)"
            }}>
                  <Icon className="h-6 w-6 transition-colors duration-300 group-hover:text-primary-foreground" strokeWidth={1.25} style={{
                color: "var(--chart-1)"
              }} />
                  <span className="absolute pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-300 h-[60px] w-[60px] rounded-md -z-0" aria-hidden="true" />
                </div>

                {}
                <style>{`
                  .group:hover [data-badge-fill="${i}"] {
                    background-color: var(--chart-1);
                  }
                `}</style>

                {}
                <h3 className="font-serif font-default text-[28px] leading-tight text-card-foreground mb-3">
                  {material.name}
                </h3>

                {}
                <p className="text-sm leading-relaxed text-muted-foreground mb-8 font-default">
                  {material.description}
                </p>

                {}
                <div className="pt-5 border-t border-border">
                  <p className="font-mono text-xs tracking-wider uppercase" style={{
                color: "var(--muted-foreground)"
              }}>
                    <span style={{
                  color: "var(--chart-1)"
                }}>FOCUS:</span>{" "}
                    <span className="text-foreground">{material.tensile}</span>
                    <span className="mx-2 opacity-50">·</span>
                    <span style={{
                  color: "var(--chart-1)"
                }}>LEVEL:</span>{" "}
                    <span className="text-foreground">{material.temp}</span>
                  </p>
                </div>
              </div>;
        })}
        </div>
      </div>

      {}
      <style>{`
        #purpose-and-future .group:hover .material-badge-icon {
          color: var(--primary-foreground);
        }
        #purpose-and-future .group:hover {
          background-color: var(--card);
        }
      `}</style>
    </section>;
}